import React, { useContext } from 'react'
import { Tabs } from 'antd'
import HeaderPage from '../../components/HeaderPage'
import { PersonalizacionTicket } from '../configuration/components/tienda/personalizacionTicket/personalizacionTicketIndex'
import { PersonalizacionSidebar } from '../configuration/components/tienda/personalizacionSidebar/personalizacionSidebarIndex'
import PlatformBrandingCard from './PlatformBrandingCard'
import { Context, useStore } from '../../context'

const { TabPane } = Tabs

function Personalizacion() {
  const [state] = useContext(Context)
  const { hasPermissions } = useStore(state)

  return (
    <>
      <HeaderPage title={'Personalización'} />
      <Tabs id={'personalizacionTabs'} defaultActiveKey="ticket">
        <TabPane tab="Ticket" key="ticket">
          <PersonalizacionTicket />
        </TabPane>
        <TabPane tab="Sidebar y colores" key="sidebar">
          <PersonalizacionSidebar />
        </TabPane>
        {hasPermissions([67]) && (
          <TabPane tab="Logo de login" key="login">
            <PlatformBrandingCard />
          </TabPane>
        )}
      </Tabs>
    </>
  )
}

export default Personalizacion
